import React from "react";
import "./Blogs.css";
import { Row, Col, Card, Button } from "react-bootstrap";
import { FaCalendarAlt, FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Blogs = () => {

    const navigate = useNavigate();
  const blogs = [
    {
      id: 1,
      name:"blog1",
      image:
        "https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=1200&q=80",
      title: "Why Regular Health Checkups Matter",
      date: "12 Apr 2026",
      desc: "Routine health screening helps detect hidden conditions early and improves long-term wellness.",
    },
    {
      id: 2,
      name:"blog2",
      image:
        "https://images.unsplash.com/photo-1581595219315-a187dd40c322?auto=format&fit=crop&w=1200&q=80",
      title: "Understanding Liver Function Tests",
      date: "10 Apr 2026",
      desc: "Learn how LFT helps evaluate liver health and diagnose common issues early.",
    },
    {
      id: 3,
      name:"blog3",
      image:
        "https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&w=1200&q=80",
      title: "When Should You Get MRI Scan?",
      date: "08 Apr 2026",
      desc: "MRI scans provide detailed imaging for joints, brain, spine and internal organs.",
    },
    {
      id: 4,
      name:"blog4",
      image:
        "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=1200&q=80",
      title: "Complete Blood Count Explained",
      date: "05 Apr 2026",
      desc: "CBC is one of the most common blood tests used to evaluate overall health.",
    },
    {
      id: 5,
      name:"blog5",
      image:
        "https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?auto=format&fit=crop&w=1200&q=80",
      title: "Symptoms You Should Never Ignore",
      date: "02 Apr 2026",
      desc: "Small warning signs can indicate bigger health concerns—know when to act.",
    },
    {
      id: 6,
      name:"blog6",
      image:
        "https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&w=1200&q=80",
      title: "Healthy Eating for Better Diagnostics",
      date: "30 Mar 2026",
      desc: "Nutrition plays a major role in cholesterol, sugar levels and overall wellness.",
    },
  ];

  return (
    <div className="blogs">
      <div className="coustom_container">
        <h2>Health Blogs & Medical Insights</h2>
        <p className="blogs_subtitle">
          Stay informed with expert healthcare articles, diagnostic awareness
          and wellness tips.
        </p>

        <Row>
          {blogs.map((blog) => (
            <Col lg={4} md={6} sm={12} key={blog.id} className="mb-4">
              <Card className="blog_card shadow border-0">
                <div className="blog_img_wrap">
                  <Card.Img src={blog.image} />
                </div>

                <Card.Body>
                  <div className="blog_date">
                    <FaCalendarAlt /> {blog.date}
                  </div>

                  <Card.Title>{blog.title}</Card.Title>

                  <Card.Text>{blog.desc}</Card.Text>

                  <Button
                    className="read_more_btn"
                    onClick={() => navigate(`/blog/${blog.name}`)}
                  >
                    Read More <FaArrowRight />
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default Blogs;
